import type { ClientDto, ClientUpdateRequest } from "../dto/ClientDto";
import { Client, type UpdateClientCommand } from "@domain/model/Client";
import { asClientId, asAddressId } from "@domain/model/Ids";
import { asDate, iso } from "@domain/model/Time";

export const clientFromDto = (d: ClientDto): Client => ({
  id: asClientId(d.id),
  name: d.name,
  addressId: asAddressId(d.addressId),
  contactName: d.contactName,
  phone: d.phone,
  email: d.email,
  version: d.version,
  createdAt: asDate(d.createdAt),
  updatedAt: asDate(d.updatedAt),
  deletedAt: d.deletedAt ? asDate(d.deletedAt) : null,
});

export const clientToDto = (c: Client): ClientDto => ({
  id: c.id,
  name: c.name,
  addressId: c.addressId,
  contactName: c.contactName,
  phone: c.phone,
  email: c.email,
  version: c.version,
  createdAt: iso(c.createdAt),
  updatedAt: iso(c.updatedAt),
  deletedAt: c.deletedAt ? iso(c.deletedAt) : null,
});

export const updateClientCmdToRequest = (
  cmd: UpdateClientCommand,
): ClientUpdateRequest => ({
  name: cmd.name ?? null,
  email: cmd.email ?? null,
  phone: cmd.phone ?? null,
  contactName: cmd.contactName ?? null,
  addressId: cmd.addressId ? String(cmd.addressId) : null,
});
